<template>
  <div class="public-content attr-management">
    <div class="region-title" style="background: #fff">属性值映射任务号</div>
    <div class="add-category">
      <el-button round type="primary" @click="type='add',addDialog=true">添加</el-button>
    </div>
    <div class="data-list">
      <el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" row-key="id" border>
        <el-table-column min-width="200px" prop="propVal" label="属性值"> </el-table-column>
        <el-table-column min-width="200px" prop="propKey" label="属性名"></el-table-column>
        <el-table-column width="200px" prop="jobCode" label="映射任务号代码"></el-table-column>
        <el-table-column min-width="200px" label="操作">
          <template slot-scope="scope">
            <span class="color-blue" @click="edit(scope)">编辑<br></span>
            <span class="color-blue" @click="deleteId=scope.row.id,deleteDialog=true">删除<br></span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--    分页-->
    <v-pagination class="v-pagination" :queryInfo="queryInfo" v-if="queryInfo.total !== ''" @changePage="changePage"></v-pagination>
    <!-- 添加/编辑 -->
    <el-dialog :close-on-click-modal="false" :title="type==='add'?'添加':'编辑'" @closed='closed' :visible.sync="addDialog" width="30%">
      <el-form ref="form" :model="spuDictJobVO" hide-required-asterisk :rules="addFormRules" label-width="120px">
        <el-form-item label="属性名:" prop="spuDictKeyId">
          <el-select v-model="spuDictJobVO.spuDictKeyId" @change="getPropVals" placeholder="请选择">
            <el-option v-for="item in propKeys" :key="item.id" :label="item.propKey" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="属性值:" prop="spuDictValueId">
          <el-select v-model="spuDictJobVO.spuDictValueId" placeholder="请选择">
            <el-option v-for="item in propVals" :key="item.id" :label="item.propVal" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="映射任务号代码:" prop="jobCode">
          <el-input v-model="spuDictJobVO.jobCode" max="1" placeholder="请输入内容" maxlength="1"></el-input>
        </el-form-item>
        <el-form-item label="预览:">
          <div class="preview">
            <img src="@/assets/images/u59590.png" alt="">
            <p>
              <span class="test1">001 001<br></span>
              <span class="test2">000 000 01-0{{spuDictJobVO.jobCode}}10</span>
            </p>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button type="primary" @click="addColor">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 删除确认 -->
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="deleteDialog" width="30%">
      <span>是否确定删除？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="deleteColor">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
 <script>
import VPagination from '@/components/Pagination/index'
import { spuDictJobList, spuDictAttrList, dictListNoPaging, dictQueryByPid, spuDictJobDelete, spuDictJobUpdate, blockShape, spuDictJobAdd } from '@/api/pms'
export default {
  name: 'attr-management',
  components: {
    VPagination
  },
  data () {
    return {
      type: '',
      blockShapeList: [],
      spuDictJobVO: {
        jobCode: '',
        spuDictKeyId: '',
        spuDictValueId: ''
      },
      propKeys: [],
      propVals: [],
      addDialog: false,
      deleteId: '',
      deleteDialog: false,
      tableData: [],
      queryInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      addFormRules: {
        spuDictKeyId: [
          { required: true, message: '请选择属性名', trigger: 'change' }
        ],
        spuDictValueId: [
          { required: true, message: '请选择属性值', trigger: 'change' }
        ],
        jobCode: [
          { required: true, message: '请填写映射任务号代码', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.getAttrTaskList()
    this.getPropKeys()
    this.getBlockShapeList()
  },
  methods: {
    edit (scope) {
      this.type = 'edit'
      this.spuDictJobVO = JSON.parse(JSON.stringify(scope.row))
      this.addDialog = true
    },
    deleteColor () {
      spuDictJobDelete(this.deleteId).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功')
          this.getAttrTaskList()
          this.deleteDialog = false
        }
      })
    },
    closed () {
      this.spuDictJobVO = {
        blockBgColor: '',
        blockShape: '',
        blockWord: '',
        blockWordColor: '',
        spuDictKeyId: '',
        spuDictValueId: ''
      }
      this.$refs.form.resetFields()
    },
    addColor () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.type === 'add') {
            spuDictJobAdd(this.spuDictJobVO).then(res => {
              if (res.data.success) {
                this.$message.success('添加成功')
                this.getAttrTaskList()
                this.addDialog = false
              }
            })
          } else if (this.type === 'edit') {
            spuDictJobUpdate({ id: this.spuDictJobVO.id, spuDictJobVO: this.spuDictJobVO }).then(res => {
              if (res.data.success) {
                this.$message.success('修改成功')
                this.getAttrTaskList()
                this.addDialog = false
              }
            })
          }
        }
      })
    },
    getBlockShapeList () {
      blockShape().then(res => {
        if (res.data.success) {
          this.blockShapeList = res.data.data
        }
      })
    },
    getPropVals (val) {
      this.spuDictJobVO.spuDictValueId = ''
      dictQueryByPid(val).then(res => {
        if (res.data.success) {
          this.propVals = res.data.data
        }
      })
    },
    getPropKeys () {
      dictListNoPaging(-1).then(res => {
        if (res.data.success) {
          this.propKeys = res.data.data
        }
      })
    },
    getAttrTaskList () {
      spuDictJobList(this.queryInfo).then(res => {
        if (res.data.success) {
          if (res.data.data.records.length === 0 && res.data.data.total !== 0 && this.queryInfo.pageNum !== 1) {
            this.queryInfo.pageNum--
            this.getAttrTaskList()
          }
          this.tableData = res.data.data.records
          this.queryInfo.total = res.data.data.total
        }
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.getAttrTaskList()
    }
  }
}
</script>
 <style scoped lang="less">
@import "./styles.less";
@deep: ~">>>";
.TRIANGLE {
  width: 0px;
  height: 0px;
  // box-sizing: border-box;
  text-align: center;
  border-left: 15px solid rgba(0, 0, 0, 0);
  border-right: 15px solid rgba(0, 0, 0, 0);
  margin-left: 8px;
  position: relative;
}
.TRIANGLE_content {
  position: absolute;
  left: -3px;
  text-align: center;
}
.SQUARE {
  width: 25px;
  height: 25px;
  margin-left: 8px;
  text-align: center;
}
.CIRCULAR {
  text-align: center;
  width: 25px;
  height: 25px;
  border-radius: 100%;
  margin-left: 8px;
}
.boxF,
.boxS,
.boxT,
.overlay {
  width: 20px;
  height: 25px;
  overflow: hidden;
}
.boxF,
.boxS {
  visibility: hidden;
}
.boxF {
  transform: rotate(120deg);
  float: left;
  margin-left: 10px;
  -ms-transform: rotate(120deg);
  -moz-transform: rotate(120deg);
  -webkit-transform: rotate(120deg);
}
.boxS {
  transform: rotate(-60deg);
  -ms-transform: rotate(-60deg);
  -moz-transform: rotate(-60deg);
  -webkit-transform: rotate(-60deg);
}
.boxT {
  text-align: center;
  transform: rotate(-60deg);
  background: no-repeat 50% center;
  background-size: 125% auto;
  -ms-transform: rotate(-60deg);
  -moz-transform: rotate(-60deg);
  -webkit-transform: rotate(-60deg);
  visibility: visible;
  line-height: 25px;
}
</style>
